/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Gift_TitleInputs */

const vi_order_gift_title = /** @type {(inputs: Order_Gift_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn quà`)
};

/**

* @param {Order_Gift_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_gift_title = /** @type {((inputs?: Order_Gift_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Gift_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_gift_title(inputs)
});